import React, { useState } from "react";
import { OFFER_INSTRUCTIONS } from "../../constants/adminDashBoard";
import { apiOfferSchedule } from "../../api/backend/admin";
import { ImgTopBtn } from "../buttons";
import { CalendarIcon, XIcon } from "../icons";
import ErrorMessageModal from "../errorMessageModal/errorMessageModal";
import DatePicker from "../datePicker/datePicker";
import TimePicker from "../timePicker/timePicker";
import { TIME_ZONES } from "../../constants/time";
import { toMinutes, convert12To24WithSeconds } from "../../utils/formatTime";
import "./offerForm.scss";

// Helper to convert a 12-hour time string (e.g., "12:00 AM") to a 24-hour time string (e.g., "00:00")

const OfferForm = ({
  onScheduleOfferCreated,
  onAttemptedSubmitOfferSchedule,
  onCancel,
}) => {
  const [workScheduleDate, setWorkScheduleDate] = useState("");
  const [location, setLocation] = useState("");
  const [startTime, setStartTime] = useState("12:00 AM");
  const [endTime, setEndTime] = useState("5:00 PM");
  const [instruction, setInstruction] = useState(OFFER_INSTRUCTIONS[0]);
  const [errorMsg, setErrorMsg] = useState("");
  const [timeZone, setTimeZone] = useState("eastern");

  const handleSubmitOffer = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    console.log("Submitting offer with values:");
    console.log("workScheduleDate:", workScheduleDate);
    console.log("startTime:", startTime, "endTime:", endTime);

    if (!workScheduleDate) {
      setErrorMsg("Please select a date.");
      return;
    }
    if (!startTime || !endTime) {
      setErrorMsg("Please provide both start and end times.");
      return;
    }

    const formattedDate = workScheduleDate.split("T")[0];
    const start24 = convert12To24WithSeconds(startTime); // "HH:mm:ss"
    const end24 = convert12To24WithSeconds(endTime);
    const startMin = toMinutes(start24);
    const endMin = toMinutes(end24);
    console.log("Formatted date:", formattedDate);
    console.log("start (min):", startMin, "end (min):", endMin);
    if (endMin <= startMin) {
      setErrorMsg("Start time must be earlier than end time (24h).");
      return;
    }
    if (onAttemptedSubmitOfferSchedule) onAttemptedSubmitOfferSchedule();

    const offerData = {
      date: formattedDate,
      location,
      startTime, // raw 12-hour string
      endTime, // raw 12-hour string
      timeZone,
      instruction,
    };

    console.log("Offer data to send:", offerData);

    try {
      const response = await apiOfferSchedule(offerData);
      console.log("Offer created successfully:", response.data);
      if (onScheduleOfferCreated) onScheduleOfferCreated(response.data.offer);
    } catch (error) {
      console.error("Error creating offer:", error);
      setErrorMsg("Failed to create offer. Please try again.");
    }
  };

  return (
    <div className="offer-form-container">
      <div className="offer-form-header">
        <h2>Create Offer</h2>
        {onCancel && (
          <ImgTopBtn
            image={
              <XIcon
                width="15"
                height="15"
                style={{
                  position: "relative",
                  marginRight: "5px",
                  top: "2px",
                }}
              />
            }
            imgTopBtnText="Cancel"
            imgTopBtnTextFontSize="1rem"
            paddingBottom="5px"
            paddingRight="5px"
            paddingLeft="5px"
            paddingTop="5px"
            imgTopBtnFontColor="var(--color-bloodred)"
            className="cancel-offer-btn"
            onClick={onCancel}
          />
        )}
      </div>
      {errorMsg && (
        <ErrorMessageModal message={errorMsg} onClose={() => setErrorMsg("")} />
      )}
      <form>
        <div className="group-form-group">
          <label htmlFor="date">Date:</label>
          <DatePicker
            showAdditionalDate={true}
            showStartDate={false}
            showEndDate={false}
            campaignExpirationDate={workScheduleDate}
            setCampaignExpirationDate={setWorkScheduleDate}
            onAdditionalDateChange={(selectedDate) => {
              console.log("Date selected:", selectedDate);
              setWorkScheduleDate(selectedDate.toISOString());
            }}
            placeholder="Select"
          />
        </div>
        <div className="group-form-group">
          <label htmlFor="teamLeader">Team Leader:</label>
        </div>
        <div className="group-form-group">
          <label htmlFor="location">Location:</label>
          <input
            type="text"
            id="location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            placeholder="Enter location"
          />
        </div>
        <div className="offer-Time">
          <label>Select Start Time</label>
          <TimePicker
            value={startTime}
            onChange={setStartTime}
            placeholder="Select"
          />
        </div>
        <div className="offer-Time">
          <label>Select End Time</label>
          <TimePicker
            value={endTime}
            onChange={setEndTime}
            placeholder="Select"
          />
        </div>
        <div className="group-form-group">
          <div className="group-form-group">
            <label>Time Zone:</label>
            <select
              value={timeZone}
              onChange={(e) => setTimeZone(e.target.value)}
            >
              {TIME_ZONES.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="group-form-group">
          <label htmlFor="instruction">Instructions:</label>
          <select
            id="instruction"
            value={instruction}
            onChange={(e) => setInstruction(e.target.value)}
          >
            {OFFER_INSTRUCTIONS.map((inst, idx) => (
              <option key={idx} value={inst}>
                {inst}
              </option>
            ))}
          </select>
        </div>
        <ImgTopBtn
          image={
            <CalendarIcon
              height="20px"
              width="20px"
              style={{ paddingRight: "5px" }}
            />
          }
          onClick={handleSubmitOffer}
          imgTopBtnText="Create Offer Schedule"
          imgTopBtnWidth="100%"
          imgTopBtnFontColor="var(--color-bloodred)"
          position="relative"
        />
      </form>
    </div>
  );
};

export default OfferForm;
